//import IErrorMessage from 'src/Models/IErrorMessage'
import { AxiosError, AxiosResponse } from 'axios'
import IGenericError from 'src/Models/Server/IGenericError'
import IGenericResult from 'src/Models/Server/IGenericResult'
import { IExceptionError } from 'src/Models/Server/Response/Exception/ExceptionError'
import { persistedStore } from 'src/Stores/PersistedStore'
import { t } from '../I18n'

export const handleResponse = <T = {}>(
  response: AxiosResponse<IGenericResult<T>>,
  resolve: (result?: T) => void,
  reject: (error: IGenericError) => void
) => {
  if (response.data.Error === null) {
    resolve(response.data.Model)
  } else {
    reject(response.data.Error)
    console.log(response.data.Error, response.data.Error.Code)
  }
}

//when authenticated
export const handleException = (
  ex: AxiosError,
  reject: (error: IExceptionError) => void
) => {
  if (ex.response) {
    switch (ex.response.status) {
      case 401:
        persistedStore.Logoff()
        //window.location.href = '/'
        break
      case 403:
        break
      case 404:
        reject({ Code: 'Not_Found', Message: ex.message })
        return

      default:
        break
    }

    if (ex.response.data) {
      reject(ex.response.data)
    }
  }

  if (ex.message) {
    reject({ Code: 'Unhandled_Exception', Message: ex.message })
  }

  console.log('unhandled error', ex.response)

  reject(t.common.serverErrors.defaultError)
}
